import * as XLSX from "xlsx-js-style";

export const exportToExcel = (
    data,
    fileName = "College Predictor",
    filters = {}
) => {

    const rows = data.map((item, index) => ({

        // Index: index + 1,

        "College Code":
            item["College Code"] || item.CollegeCode,

        College:
            item.AbbreviatedName || item.College,

        "Branch Code":
            item["Branch Code"] || item.BranchCode,

        Branch:
            item.Branch,

        // Category:
        //     item.Category,


        City:
            item.City,


        "Cutoff Percentile":
            item["Highest Percentile"] ??
            item.Percentile,

        "Cutoff Rank":
            item["Highest Rank"] ??
            item.Rank,

        // Seats:
        //     item.SI

    }));


    const worksheet = XLSX.utils.json_to_sheet([]);

    // Filter Details
    XLSX.utils.sheet_add_aoa(
        worksheet,
        [
            ["Student Name", filters.studentName || ""],
            ["Category", filters.category || ""],
            // ["Search Type", filters.searchType || ""],
            // ["Quota", filters.quota || ""],
            ["City(s)", filters.city || "All"],
            [],
        ],
        {
            origin: "A1"
        }
    );

    // Table starts from row 6
    XLSX.utils.sheet_add_json(
        worksheet,
        rows,
        {
            origin: "A6",
            skipHeader: false
        }
    );
    // Excel Styling
    const range = XLSX.utils.decode_range(worksheet["!ref"]);
    const headerRow = 5; // Row 6 in Excel (0-based)

    // Style every cell
    for (let R = range.s.r; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {

            const cellRef = XLSX.utils.encode_cell({ r: R, c: C });

            if (!worksheet[cellRef]) continue;

            const isHeader = R === headerRow;
            const isFilter = R < 3;

            worksheet[cellRef].s = {
                font: {
                    bold: isHeader || (isFilter && C === 0),
                    color: isHeader
                        ? { rgb: "FFFFFF" }
                        : { rgb: "000000" },
                    sz: isHeader ? 11 : 10
                },

                fill: {
                    fgColor: {
                        rgb: isHeader
                            ? "1F4E78"                // Header
                            : isFilter
                                ? (C === 0 ? "E2F0D9" : "FFFFFF")
                                : (R % 2 === 0 ? "F8F9FA" : "FFFFFF")
                    }
                },

                alignment: {
                    horizontal: "center",
                    vertical: "center",
                    wrapText: true
                },

                border: {
                    top: { style: "thin", color: { rgb: "D9D9D9" } },
                    bottom: { style: "thin", color: { rgb: "D9D9D9" } },
                    left: { style: "thin", color: { rgb: "D9D9D9" } },
                    right: { style: "thin", color: { rgb: "D9D9D9" } }
                }
            };
        }
    }

    // Row Heights
    worksheet["!rows"] = [
        { hpt: 22 }, // Student Name
        { hpt: 22 }, // Category
        { hpt: 22 }, // Quota
        {},
        {},
        { hpt: 28 }  // Header row
    ];

    worksheet["!cols"] = [
        { wch: 14 }, // College Code
        { wch: 45 }, // College
        { wch: 14 }, // Branch Code
        { wch: 35 }, // Branch
        { wch: 20 }, // City
        { wch: 18 }, // Cutoff Percentile
        { wch: 16 }  // Cutoff Rank
    ];

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        "Results"
    );

    XLSX.writeFile(
        workbook,
        `${filters.studentName}_${fileName}.xlsx`
    );
};
// import * as XLSX from "xlsx";

// export const exportToExcel = (data, fileName) => {

//     const worksheet = XLSX.utils.json_to_sheet(data);

//     const workbook = XLSX.utils.book_new();

//     XLSX.utils.book_append_sheet(
//         workbook,
//         worksheet,
//         "Results"
//     );

//     XLSX.writeFile(
//         workbook,
//         `${fileName}.xlsx`
//     );

// };